import React from "react";
import { CircularAvatar } from "../../commons";
import { TimesheetVsSchedulingMonthlyListType } from "../../../redux/timeSheet/timeSheetType";
import { TableHeadersType } from "../../../constant/tableHeadersConstants/tableHeadersType";
type AppProps = {
  data: TimesheetVsSchedulingMonthlyListType[] | [];
  tableHeaders: TableHeadersType[];
};
const TimesheetVsSchedulingMonthlyTableData = ({
  data,
  tableHeaders,
}: AppProps) => {
  return (
    <>
      {data?.length > 0 &&
        data?.map((timeSheetSchedulngMonthlyReportData: any) => {
          return (
            <tr className="text-left">
              {tableHeaders?.length > 0 &&
                tableHeaders?.map((header: any) => {
                  if (header?.id == "1") {
                    return (
                      <td className="text-left">
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "left",
                            alignItems: "start",
                            gap: "7px",
                          }}
                        >
                          <CircularAvatar
                            name={`${timeSheetSchedulngMonthlyReportData?.first_name} ${timeSheetSchedulngMonthlyReportData?.last_name}`}
                            image={
                              timeSheetSchedulngMonthlyReportData?.profile_pic &&
                              timeSheetSchedulngMonthlyReportData?.profile_pic
                                ?.file_url
                            }
                          />
                          <div>
                            <span>
                              {timeSheetSchedulngMonthlyReportData?.first_name}{" "}
                              {timeSheetSchedulngMonthlyReportData?.last_name}
                                <p style={{
                                      color: "#6e7491",
                                      fontSize: "12px",
                                    }}> {`${timeSheetSchedulngMonthlyReportData?.job_title ? timeSheetSchedulngMonthlyReportData?.job_title : ""} ${
                                      timeSheetSchedulngMonthlyReportData?.department ? "|" : ""
                                    } ${timeSheetSchedulngMonthlyReportData?.department !== null ? timeSheetSchedulngMonthlyReportData?.department : ""}`}</p>
                            </span>
                          </div>
                        </div>
                      </td>
                    );
                  } else if (header?.id == "2") {
                    return (
                      <td className={`text-left`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[0]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[0]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Non-Billable{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[0]
                            ?.non_billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[0]?.non_billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "3") {
                    return (
                      <td className={`text-left`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[0]
                            ?.approved_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[0]?.approved_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Pending{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[0]
                            ?.pending_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[0]?.pending_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "4") {
                    return (
                      <td className={`text-left `}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[1]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[1]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Non-Billable{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[1]
                            ?.non_billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[1]?.non_billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "5") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[1]
                            ?.approved_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[1]?.approved_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Pending{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[1]
                            ?.pending_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[1]?.pending_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "6") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[2]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[2]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Non-Billable{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[2]
                            ?.non_billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[2]?.non_billable_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "7") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[2]
                            ?.approved_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[2]?.approved_hours?.toFixed(
                                2
                              )
                            : "00"}{" "}
                        </span>
                        <p style={{ color: "#6e7491" }}>
                          Pending{" "}
                          {timeSheetSchedulngMonthlyReportData?.data[2]
                            ?.pending_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[2]?.pending_hours?.toFixed(
                                2
                              )
                            : "00"}
                        </p>
                      </td>
                    );
                  } else if (header?.id == "22") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[0]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[0]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}{" "}
                        </span>
                      </td>
                    );
                  } else if (header?.id == "33") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[1]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[1]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}{" "}
                        </span>
                      </td>
                    );
                  } else if (header?.id == "44") {
                    return (
                      <td className={`text-left}`}>
                        <span>
                          {timeSheetSchedulngMonthlyReportData?.data[2]
                            ?.billable_hours
                            ? timeSheetSchedulngMonthlyReportData?.data[2]?.billable_hours?.toFixed(
                                2
                              )
                            : "00"}{" "}
                        </span>
                      </td>
                    );
                  }

                  return null;
                })}
            </tr>
          );
        })}
    </>
  );
};

export default TimesheetVsSchedulingMonthlyTableData;
